import { useState, useCallback } from 'react';

import { EVENT_CATEGORY_CONTENT_PRODUCTION } from '../data-tracker/data-events.constants';
import { Props } from './confirm-modal.constants';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import SimpleModal from 'lib/modal/simple-modal';
import {
  SimpleModalContentStyled,
  SimpleModalVerticalActionsStyled,
} from 'lib/modal/simple-modal.styles';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { Heading18 } from 'approot/shared/styles/typography.style';
import { NegativeButton } from 'approot/shared/styles/buttons';

type ConfirmValue = string | number | undefined;

export const useConfirmModalState = () => {
  const { openModal, closeModal, isVisible } = useSimpleModalState();
  const openConfirm = useCallback(
    (value: ConfirmValue = '') => {
      openModal();
      if (value) {
        setIsConfirmValue(value);
      }
    },
    [openModal]
  );

  const [confirmableValue, setIsConfirmValue] = useState<ConfirmValue>();

  return {
    openConfirm,
    closeConfirm: closeModal,
    isConfirmVisible: isVisible,
    confirmableValue,
  };
};

const ConfirmModal = ({
  isVisible,
  shortTitle,
  title,
  confirmButtonText = 'Confirm',
  children,
  handleClose,
  handleConfirm,
  actions,
}: Props) => {
  if (!isVisible) return null;
  return (
    <SimpleModal
      isVisible={isVisible}
      headerTitle={shortTitle ? shortTitle : 'Confirm'}
      title={shortTitle ? shortTitle : 'Confirm'}
      isCloseButtonVisible
      onClose={handleClose}
      dataTrackingLabel="confirm-delete"
      dataTrackingCategory={EVENT_CATEGORY_CONTENT_PRODUCTION}
    >
      <SimpleModalContentStyled>
        {title && (
          <Heading18 as="h2" textAlignCenter marginBottom={spacing8}>
            {title}
          </Heading18>
        )}
        {children}
        <SimpleModalVerticalActionsStyled>
          {actions ? (
            actions
          ) : (
            <NegativeButton
              data-selector="confirm-button"
              onClick={() => {
                if (handleConfirm) handleConfirm();
                handleClose();
              }}
            >
              {confirmButtonText}
            </NegativeButton>
          )}
        </SimpleModalVerticalActionsStyled>
      </SimpleModalContentStyled>
    </SimpleModal>
  );
};

export default ConfirmModal;
